<template>
  <svg
    id="SVGRoot"
    width="60.0px"
    height="60.0px"
    viewBox="0 0 60.0 60.0"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <rect
        id="rect369"
        width="8.7569294"
        height="35.363388"
        x="8.2019491"
        y="21.885431"
      />
      <rect
        id="rect369-2"
        width="8.7569294"
        height="35.363388"
        x="43.443253"
        y="21.885431"
      />
      <rect
        id="rect369-6"
        width="8.7569294"
        height="35.363388"
        x="31.696146"
        y="21.885431"
      />
      <rect
        id="rect369-4"
        width="8.7569294"
        height="35.363388"
        x="19.949049"
        y="21.885431"
      />
      <path
        id="path1503-7"
        d="m 19.314635,16.131178 c 0.761392,-0.96427 1.22857,-2.157733 1.324127,-3.382644 C 20.734319,11.523624 20.457873,10.27215 19.855229,9.20147 19.771286,9.0523332 19.681221,8.9066689 19.599295,8.7564144 18.911748,7.495429 18.846963,5.9133672 19.429106,4.600388 19.446045,4.4374384 19.413712,4.2696896 19.33742,4.12471 19.261129,3.9797304 19.141178,3.8580883 18.99728,3.7797749 18.865281,3.7079369 18.714562,3.6727134 18.564286,3.6714012 c -0.150275,-0.00131 -0.300045,0.03072 -0.439519,0.086678 -0.278949,0.111916 -0.512347,0.316059 -0.707552,0.5446042 -0.619157,0.7249069 -0.884499,1.7103637 -0.843912,2.6628331 0.04059,0.9524693 0.367048,1.8752062 0.817432,2.7154438 0.0673,0.1255621 0.137419,0.2496222 0.202982,0.3761021 0.455674,0.879057 0.685223,1.874153 0.660666,2.86399 -0.02456,0.989837 -0.303168,1.972326 -0.801871,2.827706 -0.06478,0.2252 -0.0262,0.477952 0.102802,0.673577 0.129003,0.195626 0.34613,0.330633 0.57864,0.359792 0.140839,0.01766 0.285113,-0.002 0.41948,-0.04777 0.134367,-0.04575 0.259154,-0.11707 0.372884,-0.202001 0.149758,-0.111836 0.281415,-0.247855 0.388311,-0.401177 z"
      />
      <path
        id="path1503-7-6"
        d="m 43.601644,16.131178 c 0.761391,-0.964271 1.228567,-2.157734 1.324124,-3.382644 0.09556,-1.224909 -0.180888,-2.476383 -0.78353,-3.5470636 C 44.058295,9.0523336 43.96823,8.9066693 43.886305,8.7564148 43.19876,7.4954285 43.133974,5.913368 43.716115,4.6003879 43.733054,4.4374383 43.700721,4.2696894 43.62443,4.1247099 43.548138,3.9797303 43.428187,3.8580881 43.284289,3.7797747 43.15229,3.7079367 43.001571,3.6727132 42.851295,3.6714011 c -0.150275,-0.00131 -0.300045,0.03072 -0.439519,0.086677 -0.278949,0.1119161 -0.512347,0.3160591 -0.707552,0.5446043 -0.619157,0.724907 -0.884499,1.7103639 -0.843912,2.6628333 0.04059,0.9524695 0.367047,1.8752066 0.817432,2.7154441 0.0673,0.125562 0.137419,0.249622 0.202982,0.3761017 0.455674,0.879057 0.685224,1.874153 0.660667,2.86399 -0.02456,0.989837 -0.303168,1.972326 -0.801872,2.827706 -0.06478,0.2252 -0.0262,0.477952 0.102802,0.673577 0.129003,0.195626 0.34613,0.330633 0.57864,0.359792 0.140839,0.01766 0.285113,-0.002 0.41948,-0.04777 0.134367,-0.04575 0.259154,-0.11707 0.372884,-0.202001 0.149758,-0.111836 0.281415,-0.247855 0.388311,-0.401177 z"
      />
      <path
        id="path1503-7-9"
        d="m 31.008883,16.13118 c 0.761391,-0.964271 1.228567,-2.157734 1.324124,-3.382644 0.09556,-1.22491 -0.180888,-2.476383 -0.78353,-3.5470643 C 31.465534,9.0523349 31.375469,8.9066706 31.293544,8.7564161 30.605999,7.4954299 30.541213,5.9133696 31.123354,4.6003895 31.140293,4.4374399 31.10796,4.2696911 31.031668,4.1247115 30.955377,3.9797319 30.835426,3.8580898 30.691528,3.7797764 30.559529,3.7079384 30.40881,3.6727149 30.258534,3.6714027 c -0.150275,-0.00131 -0.300045,0.03072 -0.439519,0.086678 -0.278949,0.1119161 -0.512347,0.3160591 -0.707552,0.5446043 -0.619157,0.7249069 -0.884499,1.7103638 -0.843912,2.6628331 0.04059,0.9524694 0.367048,1.8752062 0.817432,2.715444 0.0673,0.1255622 0.137419,0.2496224 0.202982,0.3761024 0.455673,0.879057 0.685222,1.874153 0.660666,2.86399 -0.02456,0.989837 -0.303168,1.972326 -0.801871,2.827706 -0.06478,0.2252 -0.0262,0.477952 0.102802,0.673577 0.129003,0.195626 0.34613,0.330633 0.57864,0.359792 0.140839,0.01766 0.285113,-0.002 0.41948,-0.04777 0.134367,-0.04575 0.259154,-0.11707 0.372884,-0.202001 0.149758,-0.111836 0.281415,-0.247855 0.388311,-0.401177 z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
@keyframes moveAndFade {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  33% {
    transform: translateY(-20%) translateX(-5%);
    opacity: 0.3;
  }

  99% {
    transform: translateY(-20%) translateX(5%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
rect {
  fill: $primary-color;
}
path {
  fill: $secondary-color;
}
svg {
  max-width: 45px !important;
  &:hover {
    path {
      animation: moveAndFade 0.8s forwards;
    }
  }
}
</style>
